module.exports = __webpack_public_path__ + "img/eject.0c1499f0.svg";